module.exports = __webpack_public_path__ + "static/media/Medusa.74ffaaf9.png";